import { http, http2 } from "@/plugins/api";
import { httpbranch } from '@/plugins/api';

const base = "area";

export const getAreas = async () => {
  const response = await httpbranch.post('/commonapi/getParamArea');
  return response?.data?.data || [];
};

export const getProvinces = ({ sort = "", size = 1000 }) => {
  const url = `/${base}/provinces`;
  const params = {
    "page[size]": size,
    sort: `${sort}id`
  };

  return http.get(url, {
    params
  });
};

export const getCities = ({ sort = "", size = 1000, provinceId = "" }) => {
  const url = `/${base}/cities`;
  const params = {
    "page[size]": size,
    sort: `${sort}id`,
    "filter[provinsi_id]": provinceId
  };
  return http.get(url, {
    params
  });
};

export const getDistricts = ({ sort = "", size = 1000, cityId = "" }) => {
  const url = `/${base}/districts`;
  const params = {
    "page[size]": size,
    sort: `${sort}id`,
    "filter[kota_id]": cityId
  };
  return http.get(url, {
    params
  });
};

export const getVillages = ({ sort = "", size = 1000, districtId = "" }) => {
  const url = `/${base}/villages`;
  const params = {
    "page[size]": size,
    sort: `${sort}id`,
    "filter[distrik_id]": districtId
  };
  return http.get(url, {
    params
  });
};

export const getBranches = ({ sort = "", size = 1000, cityId = "", areaId = "" }) => {
  const url = `/${base}/branches`;
  const params = {
    "page[size]": size,
    sort: `${sort}id`
  };
  if (cityId) params["filter[city]"] = cityId;
  if (areaId) params["filter[area_id]"] = areaId;
  return http.get(url, {
    params
  });
};

export const getBranchesById = id => {
  const url = `/area/branches/${id}`;
  return http.get(url);
};

export const getBranchesByAreaId = async ({ areaId, objGroupId }) => {
  const url = "/commonapi/getParamBranchByAreaId";

  const response = await httpbranch.post(url, {
    areaId,
    objGroupId,
  });

  return response?.data?.data || [];
};
